import Typography from '@mui/material/Typography';

function stripMarkdown(text: string): string {
  return text
    .replace(/#{1,6}\s+/g, '')        // headings
    .replace(/\*\*(.+?)\*\*/g, '$1')  // bold
    .replace(/\*(.+?)\*/g, '$1')      // italic
    .replace(/__(.+?)__/g, '$1')      // bold alt
    .replace(/_(.+?)_/g, '$1')        // italic alt
    .replace(/~~(.+?)~~/g, '$1')      // strikethrough
    .replace(/!\[([^\]]*)\]\([^)]+\)/g, '$1') // images
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1') // links
    .replace(/`{1,3}[^`]*`{1,3}/g, '') // inline code
    .replace(/^\s*[-*+]\s+/gm, '')     // unordered list markers
    .replace(/^\s*\d+\.\s+/gm, '')     // ordered list markers
    .replace(/^\s*>\s+/gm, '')         // blockquotes
    .replace(/\n+/g, ' ')             // newlines to spaces
    .trim();
}

type Props = {
  description: string;
};

const EventSeriesDescriptionPreview = ({ description }: Props) => {
  const plainText = stripMarkdown(description);

  if (!plainText) {
    return null;
  }

  return (
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        mt: 1,
        mb: 1,
      }}
    >
      {plainText}
    </Typography>
  );
};

export default EventSeriesDescriptionPreview;
